import type { ReferrerName } from '../../../types/interfaces';

/**
 * Resolves referrer code/object to a display name for the Atlantic company header.
 * Empty values render as "-" (Atlantic header convention; PDF uses em dash).
 */
export function resolveAtlanticReferrerDisplayName(
  referrerName: string | ReferrerName | undefined | null,
  referrerNames: Array<{ code: string; name: string }> = [],
): string {
  if (!referrerName) return '-';
  if (typeof referrerName === 'string') {
    const trimmed = referrerName.trim();
    if (!trimmed) return '-';
    const found = referrerNames.find((rn) => rn.code === trimmed);
    return found ? found.name : trimmed;
  }
  const name = referrerName.name?.trim();
  return name || '-';
}
